import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { IApplication } from '@shared/interfaces/applications.interface';
import { IResponseAPI, IResponsePutAPI, IResponseDeleteAPI } from '@shared/interfaces/response-api.interface';
import { IApplicationModule } from '@shared/interfaces/app-module.interface';
import { map, tap } from 'rxjs/operators';

const URL = environment.apiBaseUrl;

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  constructor(private http: HttpClient) {}

  // Listar todos los modulos de las aplaicaciones que van a estar incluidas en escritorio digital
  readApplications(): Observable<IApplication[]> {
    return this.http.get<IResponseAPI>(`${URL}/mantenedores-si/v1/sistemas/`).pipe(
      map((response) => response.items),
      map((app) => {
        return app.sort((a, b) => a.posicion_menu - b.posicion_menu);
      }),
    );
  }

  createApplication(application: IApplication): Observable<IResponsePutAPI> {
    return this.http.post<IResponsePutAPI>(`${URL}/mantenedores-si/v1/sistemas/`, application);
  }

  createApplicationModule(appModule: IApplicationModule): Observable<IResponsePutAPI> {
    const systemSK = encodeURIComponent(appModule.SK);
    return this.http.post<IResponsePutAPI>(`${URL}/mantenedores-si/v1/sistemas/${systemSK}/modulos/`, appModule);
  }
  updateApplicationModule(appModule: IApplicationModule): Observable<IResponsePutAPI> {
    const systemSK = encodeURIComponent(appModule.SK);
    const path = encodeURIComponent(appModule.path);
    return this.http.put<IResponsePutAPI>(`${URL}/mantenedores-si/v1/sistemas/${systemSK}/modulos/${path}`, appModule);
  }

  deleteApplicationModule(systemSK: string, path: string): Observable<IApplicationModule> {
    systemSK = encodeURIComponent(systemSK);
    path = encodeURIComponent(path);

    console.log(`${URL}/mantenedores-si/v1/sistemas/${systemSK}/modulos/${path}`);

    return this.http
      .delete<IResponseDeleteAPI>(`${URL}/mantenedores-si/v1/sistemas/${systemSK}/modulos/${path}`)
      .pipe(map<any, IApplicationModule>((response) => response));
  }
}
